






  
  
  

  
  
  
    
  
  $('html').addClass('preview-bar-iframe-hide');
  
  
  
  

//Cookies
var transition = 300;

function getCookie(name) {
    var cookie = document.cookie;
    var prefix = name + "=";
    var begin = cookie.indexOf("; " + prefix);
    if (begin == -1) {
        begin = cookie.indexOf(prefix);
        if (begin !== 0) return 0;
    } else {
        begin += 2;
        var end = document.cookie.indexOf(";", begin);
        if (end == -1) {
        end = cookie.length;
        }
    }
  
  console.log('getCookie('+name+'), result: ' + unescape(cookie.substring(begin + prefix.length, end)));
  
    return unescape(cookie.substring(begin + prefix.length, end));
} 

        function readCookie(name) {
            var nameEQ = name + "=";
            var ca = document.cookie.split(';');
            for (var i = 0; i < ca.length; i++) {
                var c = ca[i];
                while (c.charAt(0) == ' ') c = c.substring(1, c.length);
                if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
            }
            return null;
        }

function checkCookie(cname) {
    var username = readCookie(cname);
  console.log('checkCookie('+cname+')');
    if (username !== '' && username !== null) {
      console.log('cookie is here. Value: '+ readCookie(cname));
return 1;
    } else {
console.log('cookie is not here');
      return 0;
    }
  
}

function deleteCookie(name){
   
    document.cookie = name + '=; expires=Thu, 01 Jan 1970 00:00:01 GMT;';
 
  console.log('deleteCookie('+name+')');
  
}

function setCookie(cname, cvalue) {

 var exdays = "10000";
    var d = new Date();
    d.setTime(d.getTime() + (exdays*24*60*60*1000));
    var expires = "expires="+ d.toUTCString();
    document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
  
  console.log('setCookie('+cname+', '+cvalue+')');
}

    
function checkForAttr(attr) {
        if (typeof attr !== typeof undefined && attr !== false) {
            var result = 1;
        } else {
            var result = 0;
        }
  return result;
  
  console.log('checkForAttr('+attr+'); result: ' + result);
  
    }

function getUrlParameter(sParam) {
    var sPageURL = decodeURIComponent(window.location.search.substring(1)),
        sURLVariables = sPageURL.split('&'),
        sParameterName,
        i;

    for (i = 0; i < sURLVariables.length; i++) {
        sParameterName = sURLVariables[i].split('=');

        if (sParameterName[0] === sParam) {
            return sParameterName[1] === undefined ? true : sParameterName[1];
        }
    }
  
  console.log('getUrlParameter('+sParam+'); result:' + sParameterName[1] === undefined ? true : sParameterName[1] );
  
};

  
    function priceToNumber(price) {
        var number = Number(price.replace(/[^0-9\-]+/g, "")) * 100;
      
      console.log('priceToNumber('+price+'); result:' + number);
      
        return number;
    }

    function textToNumber(number) {
        var number = Number(number.replace(/[^0-9\.-]+/g, ""));
      
      console.log('textToNumber('+number+'); result:' + number);
      
        return number;
    }
$.fn.digits = function(){ 
    return this.each(function(){ 
        $(this).text( $(this).text().replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1,") ); 
    })
}
    function numberToPrice(number) {
      var currency = '€';
        var realPrice = (number / 100).toFixed(2);
      realPrice = realPrice.replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1,"); 
        var price = currency + "" + realPrice;
      
      console.log('numberToPrice('+number+'); result:' + price);
      
        return price;
    }

      function randomNum(min, max) {
        console.log('randomNum('+min+', '+max+')');
    return Math.floor(Math.random() * (max - min + 1) + min);
  }
    
    function increment(first, last, elem){
    
    if(first > last){
     var smaller = last;
      var bigger = first;
    }
    else{
     var smaller = first;
      var bigger = last;
    }
   elem.each(function () {
    $(this).prop('Counter',smaller).animate({
        Counter: bigger
    }, {
        duration: 3000,
        easing: 'swing',
        step: function (now) {
            $(this).text(Math.ceil(now));
        }
    });
}); 
  }

    function capitalize(str){
      
    console.log('capitalize('+str+')');
 var result = str.replace(/\w\S*/g, function(txt){return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();});
    console.log('capitalize(str): ' + result);
    return result;
}
  
  function camelcase(str) {
    console.log('camelcase('+str+')');
  return str.replace(/(?:^\w|[A-Z]|\b\w|\s+)/g, function(match, index) {
    if (+match === 0) return ""; // or if (/\s+/.test(match)) for white spaces
    return index == 0 ? match.toLowerCase() : match.toUpperCase();
  });
}
  
    function stringToMath(string){
  
  console.log('stringToMath('+string+'); result: ' + eval(string));
  
return eval(string);
}

    
    Shopify.queue = [];
  
Shopify.moveAlong = function() {   
      var request = Shopify.queue.shift();
            Shopify.addItem(request.variantId, request.quantity, request.properties, Shopify.moveAlong);
       
      
        ajaxAddSuccess();
      
      console.log('Shopify.moveAlong = function()');
      
    };

        Shopify.updateAlong = function() {
          var request = Shopify.queue.shift();
     Shopify.changeItem(request.variantId, request.quantity, Shopify.updateAlong);
  

    
      console.log('Shopify.updateAlong = function()');
      
        ajaxAddSuccess();
};
  
     Shopify.removeAlong = function() { 
       var request = Shopify.queue.shift();
     Shopify.removeItem(request.variantId, Shopify.updateAlong);
  
  // If we still have requests in the queue, let's process the next one.
  if (Shopify.queue.length) {
  }
      else {
      }

          console.log('Shopify.removeAlong = function()');
      
          
};
  
  function updateCartTotal(){
    setTimeout(function(){
 jQuery.getJSON('/cart.js', function(cart) {
    for(var i=0; i<cart.items.length; i++){
      var item = cart.items[i];
      var elem = $('.product-' + item.id+' .money');
      elem.html(Shopify.formatMoney(item.price*item.quantity));
      $('.cart__subtotal').html(Shopify.formatMoney(cart.total_price));
    };
  });
      
    }, 300);
    
    console.log('updateCartTotal()');
      
};

  function updateCartnumber(cart){
    if(cart){
    $('.CartCount').text('(' + cart.item_count + ')');
  }
    else{
    
        setTimeout(function(){
          
 jQuery.getJSON('/cart.js', function(cart) {
  })
       .done(function(cart) {
    

   console.log('updateCartnumber(); qty: ' + cart.item_count + '; #CartCount length: ' + $('#CartCount').length);
   
   
   $('.CartCount').text('(' + cart.item_count + ')');
   $('.CartCount').removeClass('hide');
  })             
    }, 300);
    }
  }
  
    Shopify.addItem = function(id, qty, properties) {
        var params = {
            quantity: qty,
            id: id
        };
        if (properties != false) {
            params.properties = properties;
        }
        $.ajax({
            type: 'POST',
            url: '/cart/add.js',
            dataType: 'json', 
            data: params,
            async: false,
            success: function() {
                ajaxAddSuccess(id, qty);
              Shopify.moveAlong();
            },
            error: function(err) {
               console.log('Error adding to cart');
              $('.addToCart.justAdd .label').html('You cannot add more');
              $('.addToCart.justAdd .label').removeClass('hide');
              $('.addToCart.justAdd .loader').addClass('hide');
              
            }
        });
    //  $('.cartdrawer').addClass('toggle-cart');
      console.log('Shopify.addItem = function(id, qty, properties)');
      if(window.location.href.indexOf('sample') <= 0 && $(window).width() > 768){
         if( qty > 0) {
        $('.cartdrawer').addClass('toggle-cart'); 
           $('.site-header').addClass('not-transparent');
         }
     }
    }
  

    function push_to_queue(variantID, quantity, properties) {
        Shopify.queue.push({
            variantId: variantID,
            quantity: quantity,
            properties: properties
        });
      console.log('push_to_queue(variantID, quantity, properties), values:'+ variantID +', '+quantity + ', '+ properties);
    
    }

  
function callback() {
        //window.location.href = "/cart";
      console.log('callback()');
    }

    function ajaxAddSuccess(id, qty){
    setTimeout(function(){
          
 jQuery.getJSON('/cart.js', function(cart) {
  })
       .done(function(cart) {
   
   console.log('ajax download done');
   updateCartnumber(cart);
    $('.cart__subtotal').text(numberToPrice(cart.total_price));
   $('.cart__subtotal').removeClass('ajax-loading');
   var i;
   
   for(i = 0; i < cart.items.length; i++){
    var itemId = cart.items[i].variant_id;
     
     $('.item-holder[data-id="'+itemId+'"] .item-total-price').text(numberToPrice(cart.items[i].line_price));
   $('.item-holder[data-id="'+itemId+'"] .item-total-price').removeClass('ajax-loading');
     console.log('itemId: ' + itemId);
   }
   
   showCartPopup(cart,id,qty);
  })             
    }, 600);
  }

    function showCartPopup(cart, id,qty){
    var i;
   console.log(cart);
   for(i = 0; i < cart.items.length; i++){
    var itemId = cart.items[i].variant_id;
     if(itemId = id){
       var item = cart.items[i];
       var parent = $('[data-cart-popup-wrapper]');
       parent.find('img.cart-popup-item__image').remove();
       parent.find('.cart-popup-item__image-wrapper').append('<img src="'+item.image+'" class="cart-popup-item__image" data-cart-popup-image="">');
       parent.find('.cart-popup-item__title').html(item.product_title);
       parent.find('.cart-popup-item__image-wrapper').removeClass('hide');
       parent.find('div.cart-popup-item__image').addClass('hide');
       
       parent.find('.product-details').html('');
       var opt;
       for(opt = 0; opt < item.options_with_values.length; opt++){
         if(item.options_with_values[opt].value != 'Default Title'){
         parent.find('.product-details').append('<li class="product-details__item product-details__item--variant-option">'+item.options_with_values[opt].name+': '+item.options_with_values[opt].value+'</li>')
         }
       }
       parent.find('.cart-popup-item__quantity span[data-cart-popup-quantity]').html(qty);
       
       parent.find('.cart-popup__cta-link [data-cart-popup-cart-quantity], .site-header__cart-count [data-cart-count]').html(cart.item_count);
      
     }
   }
    $('.site-header__cart-count [data-cart-count]').html(cart.item_count);
       
   $('#CartCount').removeClass('hide');
      parent.removeClass('cart-popup-wrapper--hidden');
      $('.discounted__product-form .addToCart .loader').addClass('hide');
      $('.discounted__product-form .addToCart .label').removeClass('hide');
      
      $('.cart-popup__close').one('click', function(){
      
      parent.addClass('cart-popup-wrapper--hidden');
      })
      
    }
    
    function render(props) {
  return function(tok, i) { return (i % 2) ? props[tok] : tok; };
}



    

//preventing input number to surpass the min and max values
    
    $('input[type="number"]').bind('input', function(){
      
      var clearedValue = $(this).val().replace(/^0+/, '');
      
      if( $(this).val() !== clearedValue){
        $(this).val(clearedValue);
      }
      
      if($(this).val() > Number( $(this).attr('max'))){
        $(this).val($(this).attr('max'));
      }
      else if($(this).val() < Number( $(this).attr('min'))){
        $(this).val($(this).attr('min'));
      } 
      
      console.log("$('input[type='number']').bind('input', function(){}");
    })

    


    function smoothLoad(){
//requires css body.loading: opacity: 0;
      $('body').removeClass('loading');

window.onbeforeunload = function(){

    
 $('body').addClass('loading');
 
  
}

console.log('smoothLoad()');
}

  //smooth scroll if internal link
  
   /* $(document).on('click', 'a', function(e){
    if($(this).attr('href').indexOf('#') == 0 && $(this).attr('href').length > 1 && $($(this).attr('href')).length > 0){
      e.preventDefault();

      if($('.site-header').hasClass('fixed-header')){
        var scrolltop = $($(this).attr('href')).offset().top - $('.site-header').height() - $('.about-navigation').height() + 1;
      }
      else{
        var scrolltop =   $($(this).attr('href')).offset().top - 180;
      }
      $('html, body').animate({ scrollTop: scrolltop}, 300);
      return false;
    }
  })
*/

  
  var usedHideScroll = 0;
  
    var scrollValue = 0;

    function hideScroll(){
      scrollValue = $(document).scrollTop();
      $('html, body').addClass('no-overflow').css('top', -scrollValue).css('position', 'fixed');
      
      console.log('function hideScroll()');
      
      usedHideScroll = 1;
    }
    
       function showScroll(){
         $('html, body').css('position', 'inherit').removeClass('no-overflow').css('top', 0);
         
         $('html, body').animate({
        scrollTop: scrollValue},
        0);
         console.log('function showScroll()');
         
         usedHideScroll = 0;
      }
  
  function toggleScroll(){
    if($('html').hasClass('no-overflow')){
      showScroll();
    console.log('toggleScroll(); showing scroll');
    }
    else{
      hideScroll();
    console.log('toggleScroll(); hiding scroll');
    }
    
  }

  
  
  //date functions
  
     function compareToToday(dateText) {
// date is dd.mm.yyyy
        var inputDate = dateText.split(".");
        var today = new Date();
        inputDate = new Date(inputDate[2], inputDate[1] - 1, inputDate[0], 0, 0, 0, 0);
        today = new Date(today.getFullYear(), today.getMonth(), today.getDate(), 0, 0, 0, 0);
       
       console.log('compareToToday('+dateText+'); result: ' + inputDate < today );
       
        return inputDate < today;
          //inputDate < today, if true, result is 'False'
};

     function compareDates(date1, date2) {
// date is dd.mm.yyyy
        var inputDate1 = date1.split(".");
var inputDate2 = date2.split(".");
        inputDate1 = new Date(inputDate1[2], inputDate1[1] - 1, inputDate1[0], 0, 0, 0, 0);
        inputDate2 = new Date(inputDate2[2], inputDate2[1] - 1, inputDate2[0], 0, 0, 0, 0);
       
       console.log('compareDates('+date1+', '+date2+'); result: '+ inputDate1 < inputDate2);
       
       
        return inputDate1 < inputDate2;
          //date1 < date2, if true, result is 'False'
};

//distance between dates

  function daysDistance(firstDate,secondDate){
                
                 var startDay = new Date(firstDate);
                  var endDay = new Date(secondDate);
                  var millisecondsPerDay = 1000 * 60 * 60 * 24;

                  var millisBetween = startDay.getTime() - endDay.getTime();
                  var days = millisBetween / millisecondsPerDay;

                  // Round down.
                  return Math.abs( Math.floor(days));
    
    console.log('daysDistance('+firstDate+','+secondDate+'); result: ' + Math.abs( Math.floor(days)));
       
}

    function dateToWeekday(date){
      var d = new Date(date);
var weekday = new Array(7);
weekday[0] =  "Sunday";
weekday[1] = "Monday";
weekday[2] = "Tuesday";
weekday[3] = "Wednesday";
weekday[4] = "Thursday";
weekday[5] = "Friday";
weekday[6] = "Saturday";

      console.log('dateToWeekday('+date+')');
      
return weekday[d.getDay()];
    }
    
      
  
  
function copyToClipboard(element) {
 var $temp = $("<input>");
 $("body").append($temp);
 $temp.val($(element).val()).select();
 document.execCommand("copy");
 $temp.remove();
  
  console.log('copyToClipboard(element)');
  
}
  
function scrollToDiv(element){
  var headerHeight = 0;
  
  if($('.site-header').css('position') == 'fixed'|| $('.site-header__mobile-nav').css('position') == 'fixed'){
   headerHeight =  $('.site-header').outerHeight();
    console.log('has Fixed');
  }
  console.log('scrollin');
  $('html, body').animate({
        scrollTop: element.offset().top - headerHeight},
        300);
  
  console.log(element.offset().top);
  
   console.log('scrollToDiv(element)');
  
  }

  //parallax background effect

    function scrollLoad(objClass, shown){
    var step = shown + 1;
    var topOffset = $(objClass).offset().top;
    var height = $(objClass).height();
    var totalOffset = topOffset + height - $(window).height()*2;
    console.log('offset: ' + topOffset);
    
     var css = '<style>'+objClass+'>div:nth-child(n+'+step+')){display: none}</style>';
    
    $(window).scroll(function(){
      var top = $(window).scrollTop();
      
      console.log('compare: ' +top+'---'+ totalOffset +'shown: ' + shown +'-- total:' + $(''+objClass+'>div').length);
      
      if(top > totalOffset && $('.stamped-reviews-widget>div').length > shown ){
        
        console.log('new reviews showing: ' + $(''+objClass+'>div:hidden:not(:nth-child(n+'+( shown + step )+'))').length);
        $(''+objClass+'>div:hidden:not(:nth-child(n+'+( shown + step )+'))').slideDown(300);
        shown = shown + step;
      }
      
      height = $(objClass).height();
    totalOffset = topOffset + height - $(window).height();
    })
  }
  
  //custom modal
  
  function customModalShow(cookie, modal){
    console.log('modalClass: ' + modal.attr('class').replace(/\s/g, ''));
    if(cookie == 'cookie'){
     
      if(checkCookie(modal.attr('class').replace(/\s/g, '')) == 1){
       console.log('customModalShow('+cookie+'); opened: opened');
        
        return 'opened';
        
        
      }
      else{
        setCookie(modal.attr('class').replace(/\s/g, ''));
        
        hideScroll();
        
        fadeEffects('',modal);
        
           console.log('customModalShow('+cookie+'); opened: opening');
        
        
        $('.modal__close').click(function(){
        closeModal(modal);
        })
        console.log('customModalShow('+cookie+');opened: opening');
        
        return 'opening';
        
        
      }
      
    }
    else{
      
      hideScroll();
        
        fadeEffects('',modal);
        
           console.log('customModalShow('+cookie+');opened: opening');
        
        
        $('.modal__close').click(function(){
        closeModal(modal);
        })
        console.log('customModalShow('+cookie+'); opened: opening');
        
        return 'opening';
        
        
      
    }
    
  }
  
  function closeModal(elem){
   fadeEffects(elem, ''); 
    showScroll();
  }

        function hideAllModals(){
    $('.modal__overlay').fadeOut(300);
      if(usedHideScroll == 1){
    showScroll();
      }
    }
      //same height of elements
  
  function sameHeight(obj, child){
    obj.css('height', 'auto');
    var maxHeight = 0;
    obj.each(function(){
      if($(this).outerHeight() > maxHeight){
        maxHeight = $(this).outerHeight();
        console.log('bigger height: ' + maxHeight +'---'+$(this).outerHeight())
      }
      else{
       console.log('height not bigger: ' + maxHeight +'---'+$(this).outerHeight())
       
      }
      
    })
    obj.css('height', maxHeight);
    
    obj.each(function(){
      var diff = ($(this).height() - $(this).find('.'+child+'').outerHeight())/2;
      
      $(this).find('.'+child+'').css('top', diff);
    })
    
    console.log('sameHeight(obj, child)');
  }
 
  //check if fixed elem is over static one 
  
  function checkScrollOver(elem, elem2){
    var elemOffset = elem.offset().top;
    
    if(elem2 !== undefined){
      var elem2Offset = elem2.offset().top + elem2.outerHeight();
      
     if(elem2Offset > elemOffset){
      
      console.log('checkScrollOver(elem) = 1');
     return 1; 
    }
    else{
      console.log('checkScrollOver(elem) = 0 with elemOffset = ' + elemOffset + ' and scrollTop: ' + elem2Offset);
     return 0; 
    }
    }
    else{
    if($(document).scrollTop() > elemOffset){
      
      console.log('checkScrollOver(elem) = 1');
     return 1; 
    }
    else{
      console.log('checkScrollOver(elem) = 0 with elemOffset = ' + elemOffset + ' and scrollTop: ' + $(document).scrollTop());
     return 0; 
    }
    }
  }
  
    //if element is visible on the screen
  
  function isScrolledIntoView(elem){
    var $elem = $(elem);
    var $window = $(window);

    var docViewTop = $window.scrollTop();
    var docViewBottom = docViewTop + $window.height();

    var elemTop = $elem.offset().top;
    var elemBottom = elemTop + $elem.height();

    return ((elemBottom <= docViewBottom) && (elemTop >= docViewTop));
}
//hide context menu
  
  function hideContextMenu(obj){
    
     function absorbEvent_(event) {
      var e = event || window.event;
      e.preventDefault && e.preventDefault();
      e.stopPropagation && e.stopPropagation();
      e.cancelBubble = true;
      e.returnValue = false;
      return false;
    }

    function preventLongPressMenu(node) {
      node.ontouchstart = absorbEvent_;
      node.ontouchmove = absorbEvent_;
      node.ontouchend = absorbEvent_;
      node.ontouchcancel = absorbEvent_;
    }

      preventLongPressMenu(obj);
   
  }
  


function swipeFunctions(direction){
  
      if($('html').hasClass('nav-opened') && direction == 'left'){
     hideNav();
    }
      
      if($('#ajaxCart').hasClass('active') && direction == 'right'){
        hideAjaxCart();
      }
}

var direction = '';

    $("html")
    .on('mousedown touchstart', function (e) {
            xDown = e.pageX || e.originalEvent.touches[0].pageX;
            yDown = e.pageY || e.originalEvent.touches[0].pageY;
            console.log("(x,y) = (" + xDown + "," + yDown +")");
        })
        .on('mouseup touchend',function (e) {
            xUp = e.pageX || e.originalEvent.changedTouches[0].pageX;
            yUp = e.pageY || e.originalEvent.changedTouches[0].pageY;
            console.log("(x,y) = (" + xUp + "," + yUp +")");
            if (xDown != xUp || yDown != yUp) {
                console.log('Swiped');   
            }
      if(Math.abs((yDown - yUp)) > 50 || Math.abs((xDown - xUp)) > 50){
    if(Math.abs((yDown - yUp)) > Math.abs((xDown - xUp))){
        
          console.log('Vertical swipe');
        
        if(yDown > yUp){
         console.log('up');
         direction = 'up';
        }
        else{
          console.log('swipe down');
          direction = 'down' ;
        }
      }
      else{
        console.log('Horzontal swipe');
        
        if(xDown > xUp){
         console.log('swipe left');
         direction = 'left' ;
        }
        else{
          console.log('swipe right');
          direction = 'right' ;
        }
      }
      console.log('swipe: xDown: '+ xDown + '; yDown:' + yDown + '; xUp:' + xUp + '; yUp:' + yUp);
      }
      else{
       console.log('no swipe detected');
        direction = 'no-swipe';
      }
      
  console.log('direction: ' + direction);
      swipeFunctions(direction);
      
        })
    ; 
  
  
  


  function imageZoom() {
var img, lens, result, ar;
 
  var cx, cy;
  
  img = $('.product-single__media-wrapper:not(.hide) .zoom-image.feature-row__image');
    if(img.length > 0){
      var x = setInterval(function(){
  result = $('.product-single__media-wrapper:not(.hide) .img-zoom-result');
  var imgRealWidth = img[0].naturalWidth;
  result.css('height', result.outerWidth());
        if(imgRealWidth > 0 && img.outerWidth() > 0){
  var lensRatio = imgRealWidth/img.outerWidth();
      console.log('imgRealWidth: '+ imgRealWidth +'; outerWidth: '+ img.outerWidth() +' lensRatio: ' + lensRatio);
  lens = $('.product-single__media-wrapper:not(.hide) .img-zoom-lens');
  var lensSize = img.outerWidth()/lensRatio;
  lens.css('height', lensSize).css('width', lensSize);
  
  
  /*calculate the ratio between result DIV and lens:*/
  cx = result.outerWidth() / lensSize;
  cy = result.outerHeight() / lensSize;
  /*set background properties for the result DIV:*/
  result.css('background-image', "url('" + img.attr('src') + "')");
  result.css('background-size', (img.outerWidth() * cx) + "px " + (img.outerHeight() * cy) + "px");
  lens.css('background-image', "url('" + img.attr('src') + "')");
  lens.css('background-size', img.outerWidth() + "px " + img.outerHeight() + "px");
  
 /*execute a function when someone moves the cursor over the image, or the lens:*/
  lens.on("mousemove", moveLens);
  
  img.on("mousemove", moveLens);
  /*and also for touch screens:*/
  lens.on("touchmove", moveLens);
  img.on("touchmove", moveLens);
  
  /* removing hover effect on mobile */
  lens.on("touchstart", function(){$('body').addClass('zoomStart')});
                                   img.on("touchstart", function(){$('body').addClass('zoomStart')});
                                  lens.on("touchend", function(){$('body').removeClass('zoomStart')});
                                 img.on("touchend", function(){$('body').removeClass('zoomStart')});
  function moveLens(e) {
    var pos, x, y;
    /*prevent any other actions that may occur when moving over the image:*/
    e.preventDefault();
    /*get the cursor's x and y positions:*/
    pos = getCursorPos(e);
    /*calculate the position of the lens:*/
    x = pos.x - (lensSize / 2);
    y = pos.y - (lensSize / 2);
    /*prevent the lens from being positioned outside the image:*/
    if (x > img.outerWidth() - lensSize) {x = img.outerWidth() - lensSize;}
    if (x < 0) {x = 0;}
    if (y > img.outerHeight() - lensSize) {
      y = img.outerHeight() - lensSize;
    }
    if (y < 0) {y = 0;}
    
    console.log('2) x: ' +x+ '; y:' + y + '; lens.outerHeight: ' +lensSize + 'img.outerHeight(): ' + lensSize);
    /*set the position of the lens:*/
    lens.css('left', x + "px");
    lens.css('top', y + "px");
    /*display what the lens "sees":*/
    result.css('background-position',"-" + (x * cx) + "px -" + (y * cy) + "px");
    result.css('left',(x - result.outerWidth()/2));
    result.css('top', + (y - result.outerHeight() - 10) + "px");
    lens.css('background-position',"-" + x + "px -" + y + "px");
  }
  function getCursorPos(e) {
    e = e || window.event;
    if(e.originalEvent.touches){
      e= e.originalEvent.touches[0];
    }
    var a, x = 0, y = 0;
    /*get the x and y positions of the image:*/
    a = img[0].getBoundingClientRect();
    
    /*calculate the cursor's x and y coordinates, relative to the image:*/
    x = e.pageX - a.left;
    y = e.pageY - a.top;
    //console.log('x: ' +x+ '; y:' + y + "; e.pageY: " + e.pageY +'; a.top: '+ a.top + "; e.pageX: " + e.pageX + '; a.left: ' + a.left);
    
    /*consider any page scrolling:*/
    x = x - window.pageXOffset;
    y = y - window.pageYOffset;
    return {x : x, y : y};
  }
          clearInterval(x);
        }
        },200)
    }
}

$(document).ready(function(){
  $('html').addClass('zoomReady');
    
    if($(window).width() > 768){
      setTimeout(function(){ 
        
        imageZoom();
      },600);
    
    $('.product-single__thumbnail').click(function(){
      setTimeout(function(){ imageZoom(); }, 600);
    })
    }
    else{
     console.log('small screen, no need for that'); 
    }
  
  
  $('.logo-bar-slider').each(function(){
    $(this).slick({
     infinite: true,
      slidesToShow: $(this).data('per-slide'),
  slidesToScroll:  $(this).data('per-slide'),
      autoplay: $(this).data('autoplay'),
      responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 3
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 3
      }
    }
    // You can unslick at a given breakpoint now by adding:
    // settings: "unslick"
    // instead of a settings object
  ]
    })
  })
  
  $('.images-slider').each(function(){

    if($(this).data('to-scroll')){
      var toScroll = $(this).data('to-scroll');
    } 
    else{
      var toScroll = 1;
    }
    
    $(this).slick({
        dots: true,
        infinite: $(this).data('infinite'),
        autoplay: $(this).data('autoplay'),
        autoplaySpeed: $(this).data('autoplay-speed'),
  speed: 300,
        slidesToShow: $(this).data('slides'),
  slidesToScroll: toScroll,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 3
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }
    // You can unslick at a given breakpoint now by adding:
    // settings: "unslick"
    // instead of a settings object
  ]
})
  })

  
  $('.products-slider').each(function(){
    $(this).slick({
     infinite: true,
      adaptiveHeight: true,
      slidesToShow: $(this).data('per-slide'),
  slidesToScroll:  $(this).data('per-slide'),
      autoplay: $(this).data('autoplay'),
      responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }
    // You can unslick at a given breakpoint now by adding:
    // settings: "unslick"
    // instead of a settings object
  ]
    })
  })
  
  
  if(typeof strings != 'undefined'){
   custRelProdOnDocReady(); 
  }
  
  if($('.discounted__product-wrapper').length > 0){
    discProductsOnDocReady();
  }
  
  if($('#enquireFor').length > 0){
    contactOnDocReady();
    console.log('working on contact');
  }
  
$(".hero-images-holder.enable-transition .image-holder").hover(
  function(e){
   var parentOffset = $(this).offset(); 
  
  var middleX = parentOffset.left/2;
  var middleY = parentOffset.top/2;
  
   var relX = e.pageX - parentOffset.left;
   var relY = e.pageY - parentOffset.top;
  
  var topPercent = relY/$(this).outerHeight()*100;
      var leftPercent = relX/$(this).outerWidth()*100;
        var rightPercent = 100 - relX/$(this).outerWidth()*100;
          var bottomPercent = 100 - relY/$(this).outerHeight()*100;
  
  console.log('topPercent: ' + topPercent + ';leftPercent: ' + leftPercent + '; rightPercent: ' + rightPercent + '; bottomPercent: '+bottomPercent);

  if(topPercent <= leftPercent && topPercent <= rightPercent && topPercent <= bottomPercent){
    $(this).find('.title-holder').css('top','-100%').css('left', 0);
    console.log('animating in top');

  }
  else if(leftPercent <= topPercent && leftPercent <= rightPercent && leftPercent <= bottomPercent){
    $(this).find('.title-holder').css('left','-100%').css('top', 0);
    console.log('animating in left');
  
  }
  else if(rightPercent <= topPercent && rightPercent <= leftPercent && rightPercent <= bottomPercent){
    $(this).find('.title-holder').css('left','100%').css('top', 0);
    console.log('animating in right');
  
    
  }
  else{
    $(this).find('.title-holder').css('top','100%').css('left', 0);
    console.log('animating in bottom');
    
  }
    $(".image-holder").removeClass('active');
     $(this).addClass('active');
    
    
    $(this).find('.title-holder').animate({
    "top": 0,
    "left": 0
  }, 300);
},
  
  function(e){
var parentOffset = $(this).offset(); 
  
  var middleX = parentOffset.left/2;
  var middleY = parentOffset.top/2;
  
   var relX = e.pageX - parentOffset.left;
   var relY = e.pageY - parentOffset.top;
  
  var topPercent = relY/$(this).outerHeight()*100;
      var leftPercent = relX/$(this).outerWidth()*100;
        var rightPercent = 100 - relX/$(this).outerWidth()*100;
          var bottomPercent = 100 - relY/$(this).outerHeight()*100;
  
  console.log('topPercent: ' + topPercent + ';leftPercent: ' + leftPercent + '; rightPercent: ' + rightPercent + '; bottomPercent: '+bottomPercent);

  if(topPercent <= leftPercent && topPercent <= rightPercent && topPercent <= bottomPercent){
  
    var topVal = '-100%';
    var leftVal = 0;
    console.log('animating out top');
  }
  else if(leftPercent <= topPercent && leftPercent <= rightPercent && leftPercent <= bottomPercent){
  
    var topVal = 0;
    var leftVal = '-100%';
    console.log('animating out left');
  }
  else if(rightPercent <= topPercent && rightPercent <= leftPercent && rightPercent <= bottomPercent){
   
    var topVal = 0;
    var leftVal = '100%';
  
    console.log('animating out right');
  }
  else{
    var topVal = '100%';
    var leftVal = 0;
    console.log('animating out down');
    
  }
      $(this).find('.title-holder').animate({
        "left": leftVal,
        "top": topVal
  }, 300);
     
}
);

  $('[data-section-type="featured-collections"] .coll-title').click(function(){
    if(!$(this).hasClass('active')){
    var index = $(this).data('index');
    var parent = $(this).parents('[data-section-type="featured-collections"]');

    parent.find('.coll-title').removeClass('active');
    $(this).addClass('active');
    parent.find('.coll-body:not([data-index="'+index+'"])').slideUp(300);
    parent.find('.coll-body[data-index="'+index+'"]').slideDown(300);
    }
  })

  $('.product-form__input--quantity').bind('input', function(){
    var parent = $(this).parents('form');
    console.log('qty changed');
    var newUrl = parent.find('.product-enquire-btn').data('href') + $(this).val();
parent.find('.product-enquire-btn').attr('href', newUrl);
    
  })
$('.instagram-content-holder').each(function() {
    var section = $(this);
    var imgCount = 0;
    console.log('imgCount is: ' + imgCount);
    var contFound = 0;

    // Select the node that will be observed for mutations
    var targetNode = section.find('#insta-feed')[0];

    // Options for the observer (which mutations to observe)
    var config = { childList: true, subtree: true };

    // Callback function to execute when mutations are observed
    var callback = function(mutationsList, observer) {
        mutationsList.forEach(function(mutation) {
            if (mutation.type === 'childList') {
                console.log('insta slider modified');

                var appWrapper = $(mutation.target);
                if (contFound === 0) {
                    if (appWrapper.find('.instafeed-new-layout-wrapper .instafeed-new-layout-item').length > 0) {
                        imgCount = appWrapper.find('.instafeed-new-layout-wrapper .instafeed-new-layout-item').length;
                        console.log('insta image count: ' + imgCount);

                        var imagesArr = [];
                        for (var i = 1; i <= imgCount; i++) {
                            imagesArr.push(appWrapper.find('.instafeed-new-layout-item:nth-child(' + i + ') img').attr('data-instafeed-src'));
                        }

                        var imagesHTML = '';
                        for (var a = 0; a < imagesArr.length; a++) {
                            console.log('insta image found');

                            imagesHTML += '<div class="insta-slide">' +
                                '<a href="#' + (a + 1) + '-insta-feed">' +
                                '<div class="insta-img-wrapper padding-0">' +
                                '<div class="insta-img-holder">' +
                                '<img src="' + imagesArr[a] + '"/>' +
                                '</div>' +
                                '</div>' +
                                '</a>' +
                                '</div>';
                        }
                        section.find('.instagram-slider').append(imagesHTML);

                        section.find('.instagram-slider').slick({
                            infinite: true,
                            adaptiveHeight: true,
                            slidesToShow: section.find('.instagram-slider').data('per-slide'),
                            slidesToScroll: section.find('.instagram-slider').data('per-slide'),
                            responsive: [
                                {
                                    breakpoint: 600,
                                    settings: {
                                        slidesToShow: section.find('.instagram-slider').data('mobile-per-slide'),
                                        slidesToScroll: section.find('.instagram-slider').data('mobile-per-slide')
                                    }
                                }
                            ]
                        });

                        contFound = 1; // Set contFound to 1 to prevent repeated execution
                    } else {
                        console.log('containers not found');
                    }
                }

                section.find('.insta-slide a').on('click', function() {
                    var id = $(this).attr('href');
                    $(id).attr('style', 'display: flex !important');
                    $(document).on('click', id + ' .arrows object', function() {
                        $(id).attr('style', 'display: none !important');
                    });
                });
            }
        });
    };

    // Create an observer instance linked to the callback function
    var observer = new MutationObserver(callback);

    // Start observing the target node for configured mutations
    observer.observe(targetNode, config);
});

})